module.exports = __webpack_public_path__ + "static/media/panda.2b27a5df.png";